@if(specialistSignUpDetails(); as details) {
<div>
	<div class="row mb-1">
		<div class="mt-2 col">
			<div class="d-flex">
				<div class="fw-bold me-2">Volunteer's timezone:</div>
				<div class="fst-italic">{{details.volunteerTimeZoneName}}</div>
			</div>
		</div>
	</div>
	<div class="row mb-1">
		<div class="mt-2 col">
			<div class="d-flex">
				<div class="fw-bold me-1">All times are shown in:</div>
				<div class="fst-italic">{{details.userTimeZoneName}}</div>
			</div>
		</div>
	</div>
	<div class="row mb-4">
		<div class="col">
			<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()" [rows]="allEvents()"></grid-content>
		</div>
	</div>
</div>
}